export default function LoaderReviewersStatistics() {
  return (
    <div className="grid grid-cols-12 gap-2">
      {[...Array(24)].map((_, index) => (
        <div
          key={index}
          className="border-muted group col-span-12 h-[500px] animate-pulse rounded-md border-2 bg-white lg:col-span-6 xl:col-span-6"
        ></div>
      ))}
    </div>
  )
}
